import React from 'react';
import { Link } from 'react-router-dom';
import { ClipboardPlus, UserPlus, Receipt, Images, Home, Package, Settings } from 'lucide-react';

const ACTIONS = [
  { to: '/admin/clients', label: 'New Order for Client', hint: 'Pick a client, then New Order', icon: ClipboardPlus, testid: 'dashboard-action-new-order', primary: true },
  { to: '/admin/clients?add=1', label: 'Add Client', hint: 'Create a client profile', icon: UserPlus, testid: 'dashboard-action-add-client' },
  { to: '/admin/real-estate-orders?status=delivered&service=all', label: 'Invoices', hint: 'Delivered orders awaiting payment', icon: Receipt, testid: 'dashboard-action-invoices' },
  { to: '/admin/portfolio', label: 'Portfolio', hint: 'Showcase & featured properties', icon: Images, testid: 'dashboard-action-portfolio' },
];

const HUB_LINKS = [
  { to: '/admin/real-estate-orders', label: 'Real Estate Orders', icon: Home, testid: 'admin-real-estate-orders-link' },
  { to: '/admin/orders', label: 'All Service Orders', icon: Package, testid: 'admin-orders-link' },
  { to: '/admin/settings', label: 'Invoice & Pricing Settings', icon: Settings, testid: 'admin-settings-link' },
];

export const QuickActions = () => (
  <div className="grid grid-cols-2 lg:grid-cols-4 gap-3" data-testid="dashboard-quick-actions">
    {ACTIONS.map(({ to, label, hint, icon: Icon, testid, primary }) => (
      <Link key={label} to={to} data-testid={testid}
        className={`group rounded-xl p-4 border transition-[transform,background-color,border-color] duration-200 hover:-translate-y-0.5 ${
          primary ? 'bg-[#C6A14A] border-[#C6A14A] text-[#050816] hover:bg-[#D4AF5A]' : 'bg-[#0f1724] border-white/10 hover:border-[#C6A14A]/50 text-white'}`}>
        <Icon className={`h-5 w-5 mb-3 ${primary ? 'text-[#050816]' : 'text-[#C6A14A]'}`} />
        <p className="text-sm font-medium">{label}</p>
        <p className={`text-xs mt-1 hidden sm:block ${primary ? 'text-[#050816]/70' : 'text-[#E8E4DE]/50'}`}>{hint}</p>
      </Link>
    ))}
  </div>
);

export const HubLinks = () => (
  <div className="flex flex-wrap gap-2" data-testid="dashboard-hub-links">
    {HUB_LINKS.map(({ to, label, icon: Icon, testid }) => (
      <Link key={to} to={to} data-testid={testid}
        className="inline-flex items-center gap-2 rounded-full border border-white/10 px-4 py-2 text-sm text-[#E8E4DE]/80 hover:border-[#C6A14A]/50 hover:text-[#C6A14A] transition-colors">
        <Icon className="h-4 w-4" />{label}
      </Link>
    ))}
  </div>
);
